import { type PopupQuiz, type PopupQuizPayload } from '@editor2/types/pageElements';

export const createPopupQuizConfigJson = (element: PopupQuizPayload) => {
	return JSON.stringify(element, null, 2);
};

export const getPopupQuizPayload = (element: PopupQuiz) => {
	const { config, ...elementEntity } = element;
	const { family_id, id, metadata, type, ...payload } = JSON.parse(config);

	return { ...elementEntity, ...payload };
};
